import React from "react";
import TrackVisibility from "react-on-screen";
import Skill from "../Items/Skill";

const skillData = {
  skillContent:
    "Always responsible for reviewing PR's, prioritizing Backlog tasks, participating in Gromming meetings for future features, developing new features with code: <strong> 100% Tested, 100% accessible and with high performance.</strong>",
  progressData: [
    {
      id: 1,
      name: "React Web",
      percentage: 100,
    },
    {
      id: 2,
      name: "Typescript & Javascript",
      percentage: 89,
    },
    {
      id: 9,
      name: "NodeJs / NestJs / Prisma",
      percentage: 75,
    },
    {
      id: 3,
      name: "React Native (Mobile)",
      percentage: 97,
    },
    {
      id: 4,
      name: "Git Flow",
      percentage: 100,
    },
    {
      id: 5,
      name: "Accessibility (A11Y)",
      percentage: 88,
    },
    {
      id: 6,
      name: "Tests - Jest, Webdrive.IO, Cypress",
      percentage: 77,
    },
    {
      id: 7,
      name: "HTML & CSS",
      percentage: 100,
    },
    {
      id: 8,
      name: "Wordpress",
      percentage: 85,
    },

    {
      id: 10,
      name: "Agile - Scrum, Sprint, Kanban",
      percentage: 92,
    },
  ],
};

function Skills() {
  return (
    <>
      <p
        className="mb-0"
        dangerouslySetInnerHTML={{ __html: skillData.skillContent }}
      />
      <div className="mt-5">
        <div className="row -mt-50">
          {skillData.progressData.map((progress) => (
            <div className="col-md-6 mt-50" key={progress.id}>
              <TrackVisibility once>
                <Skill progress={progress} />
              </TrackVisibility>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Skills;
